import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cmc_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [discount, setDiscount] = useState(() => localStorage.getItem("cmc_discount") || "");

  useEffect(() => {
    localStorage.setItem("cmc_cart", JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    if (discount) localStorage.setItem("cmc_discount", discount);
    else localStorage.removeItem("cmc_discount");
  }, [discount]);

  const add = (product, size, qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.product_id === product.id && i.size === size);
      if (idx >= 0) {
        const next = [...cur];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...cur, {
        product_id: product.id, name: product.name, price: product.price,
        size, quantity: qty, image: product.image,
      }];
    });
    setOpen(true);
  };
  const remove = (product_id, size) =>
    setItems((cur) => cur.filter((i) => !(i.product_id === product_id && i.size === size)));
  const updateQty = (product_id, size, qty) =>
    setItems((cur) => cur.map((i) =>
      i.product_id === product_id && i.size === size ? { ...i, quantity: Math.max(1, qty) } : i
    ));
  const clear = () => setItems([]);

  const subtotal = useMemo(
    () => items.reduce((s, i) => s + i.price * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  // Known discount codes (mirrored for UI; backend is source of truth)
  const DISCOUNTS = { TIKTOK10: 0.10 };
  const discountPct = discount && DISCOUNTS[discount] ? DISCOUNTS[discount] : 0;
  const discountAmount = useMemo(() => Math.round(subtotal * discountPct * 100) / 100, [subtotal, discountPct]);
  const total = Math.max(0, Math.round((subtotal - discountAmount) * 100) / 100);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, subtotal, count, open, setOpen, discount, setDiscount, discountAmount, total }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
